import React from "react";
import { PartnerCard } from "./ui/partner-card";
import { Flex } from "@radix-ui/themes";
import { BlueField } from "./ui/blue-field";

export function MHP() {
  return (
    <PartnerCard
      logo={
        <img
          className="partner-logo"
          src="/Images/barometer/2025/massMediaLogos/mhp-logo.png"
          alt="partner logo"
        />
      }
      heading="Генеральний партнер"
    >
      <Flex direction="column" gap="5">
        <p>
          МХП — міжнародна компанія у сфері харчових та агротехнологій. Має
          виробничі потужності в Україні та Південно-Східній Європі
        </p>
        <p>
          Експортує продукцію в понад 70 країн світу та розвиває понад 15
          брендів їжі. Компанія обʼєднує 36 тис працівників в Україні та за
          кордоном
        </p>

        <BlueField>
          Входить до 20 кращих роботодавців України за версією Forbes
        </BlueField>

        <p>
          Компанія відома своїм системним підходом до управління
          результативністю та розвитку талантів, комплексною роботою над
          задоволеністю та залученістю персоналу, програмами розвитку лідерів,
          програмами турботи про здоровʼя та підтримки ветеранів. Все це формує
          команду many happy people, яка годує світ
        </p>
      </Flex>
    </PartnerCard>
  );
}
